import { fork, all } from 'redux-saga/effects';

import sagaManager from './sagaManager';

export default function* rootSaga() {
  yield all([fork(sagaManager.getRootSaga())]);
}
